export const getProjectStatus = (project) => {
  const status = project.project_status || project.status;
  if (typeof status === "string" && status.trim() && !/^\d+$/.test(status.trim())) return status.trim();
  if (project.progress !== null && project.progress !== undefined && project.progress !== "") {
    const progress = Number(project.progress);
    if (Number.isFinite(progress)) return progress >= 100 ? "Completed" : progress > 0 ? "In Progress" : "Planning";
  }
  return "Not specified";
};
export const projectStatusClass = (status) => status.toLowerCase().replace(/\s+/g, "-");
